.scrollable-selection-container {
    overflow-x: auto;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE/Edge */

    /* Grid layout styles */
    display: grid;
    grid-auto-flow: column;
    /* We set this style inline in the component based on the number of items */
    /* grid-template-columns: repeat(n, minmax(200px, 1fr)); */
}

.scrollable-selection-container::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
}

.scrollable-selection-item {
    cursor: pointer;
}

.scroll-button {
    padding: 5.5px 8px;
}

.scroll-button-container button {
    padding: 0;
}
